import currency from "currency.js";
import { Control, FieldPath, useWatch } from "react-hook-form";
import { FormWithAmount } from "../types";

function calculateMonthlyIncome(annualIncome: number): currency {
  const annual = currency(annualIncome, { increment: 0.01 });
  const distributed = annual.distribute(12);
  const monthly = distributed[distributed.length - 1];
  return monthly ?? currency(0);
}

function useMonthlyIncomeCalculator<T extends FormWithAmount>(control: Control<T>) {
  const annualIncome = useWatch({
    control,
    name: "amount" as FieldPath<T>,
  }) as number;

  if (!annualIncome || annualIncome.toString() === "$") return "";

  const monthlyIncome = calculateMonthlyIncome(annualIncome);

  return `${monthlyIncome.format()}`;
}

export { useMonthlyIncomeCalculator };
